export default __webpack_public_path__ + "static/media/AcornMallFastFood_04.686754a5.png";